"use client";
import { Button } from "@/components/atoms/button/button";
import { cn } from "@/lib/utils";

import { useTalkToSpecialistContext } from "./context";

export function TalkToSpecialistAction({
  hideOnMobile,
  variant = "primary",
  asChild,
  children,
}: {
  hideOnMobile?: boolean;
  variant?: "primary" | "secondary";
  asChild?: boolean;
  children?: React.ReactNode;
}) {
  const { setOpen } = useTalkToSpecialistContext();

  return (
    <Button
      variant={variant === "primary" ? undefined : variant}
      color={variant === "secondary" ? undefined : variant}
      size="sm"
      className={cn({ "hidden md:flex": hideOnMobile })}
      onClick={() => setOpen(true)}
      asChild={asChild}
    >
      {children ?? "Falar com especialista"}
    </Button>
  );
}
